export default token => {
    if (!window.atob) {
        throw new Error('Not able to parse Base64');
    }

    const segments = token.split('.');
    if (segments.length !== 3) {
        throw new Error('Not enough or too many segments');
    }

    const payload = segments[1];

    return JSON.parse(window.atob(payload));
};
